import React from "react";
import "../../City/CityInfo/style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "components/Button/Button";
import CoverPhoto from "pages/City/CityInfo/CoverPhoto";
import SocialMedia from "pages/City/CityInfo/SocialMedia";
import CityAdmin from "pages/City/CityInfo/CityAdmin";
import PlaceholderImage from "Assets/present-img.png";
//import { apiUrl, myHeaders_Autorized, HeaderConfig,events_list_api, channel_list_api, myHeaders_With_Cache_Control } from "Api/Api";
import { org_friendly_url, apiUrl, myHeaders_Autorized, HeaderConfig, channel_list_api, myHeaders_With_Cache_Control } from "Api/Api";
import axios from 'axios';
import { NavLink } from "react-router-dom";
import { local_routes } from 'utils/Routes';
import { get_current_unix_stamp } from 'utils/Helper';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import Select from 'react-select';
import ShareAccessModalButton from 'components/Modals/ShareAccessModalButton'

class ChannelInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            channelFriendly_url: null,
            channelDescription: '',
            channelEntityId: null,
            updateCityLoader: false,
            channelImg: null,
            receivedImg: null,
            // loader meta data
            loading: true,
            // Social meta data
            twitter: null,
            facebook: null,
            instagram: null,
            // changed meta data
            channelAdminData: [],
            presentationDataArr: [],
            selectedOption: null,
            selectedData: null,
        };
        // NEW - replicating locationInfo in CityInfo component
        this.channelInfo = {};
        /*
        this.channel_uuid = "";
        const { match: { params: { channel_uuid } = {} } = {} } = this.props;
        if (channel_uuid) {
          this.channel_uuid = channel_uuid;
        }
        */
        
        this.workspace_base_url = "";
        if (org_friendly_url) {
            this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
            local_routes.channels = local_routes.teams;
            local_routes.managechannel = local_routes.manageteam;
        }
        
    }

    componentDidMount = async function () {
        this.setState({ loading: true });
        
        //const { match: { params: { friendly_url } = {} } = {} } = this.props;
        //let [channelDataApiRes] = await Promise.all([
        //    axios.get(`${apiUrl}channels/${friendly_url}`, myHeaders_With_Cache_Control)
        //])
        //if (channelDataApiRes && channelDataApiRes.data) {
            //let resData = channelDataApiRes.data;
            let resData = this.props.channel_data;
            this.channelInfo = resData

            let channel_uuid = resData.entity_uuid;
            let [channelUserDataApiRes = [], presentationDataApiRes = []] = [];
            if (this.workspace_base_url) {
                [channelUserDataApiRes, presentationDataApiRes] = await Promise.all([
                    axios.get(`${apiUrl}channels/${channel_uuid}/users`, HeaderConfig),
                    //axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations?sort[spotlighted_time]=desc`, myHeaders_With_Cache_Control),
                    axios.get(`${apiUrl}organizations/${org_friendly_url}/presentations?sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}`, myHeaders_With_Cache_Control),
                ]);
            } else {
                [channelUserDataApiRes, presentationDataApiRes] = await Promise.all([
                    axios.get(`${apiUrl}channels/${channel_uuid}/users`, HeaderConfig),
                    //axios.get(`${apiUrl}channels/${channel_uuid}/presentations?sort[spotlighted_time]=desc`, myHeaders_With_Cache_Control),
                    axios.get(`${apiUrl}channels/${channel_uuid}/presentations?sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}`, myHeaders_With_Cache_Control),
                ]);
            }
            let presentationData = presentationDataApiRes.data;
            let presentationTempArr = []; let selectedTempArr = [];
            if (channelUserDataApiRes.data) {
                

                let channelAdminTempArr = []; let channelAdminApiRes = channelUserDataApiRes.data;
                channelAdminApiRes.forEach((item) => {
                    if (item.access_level === "channel_admin" || "admin") {
                        channelAdminTempArr.push(item);
                    }
                })
                this.setState({ channelAdminData: channelAdminTempArr })
            }
            if (presentationData.length !== 0) {
                presentationData.forEach((item, index) => {
                    if (item.length !== 0) {
                        presentationTempArr.push({
                            entity_uuid: item.entity_uuid,
                            value: index,
                            label: item.entity_name
                        })
                    }
                    if (index === 0) {
                        selectedTempArr.push({ label: item.entity_name })
                    }
                })
            }
            this.setState({ presentationDataArr: presentationTempArr })
            this.setState({ selectedData: selectedTempArr })
            this.setState({
                channelEntityId: resData.entity_uuid,
                channelImg: resData.logo_image_url,
                channelFriendly_url: resData.friendly_url,
                twitter: resData.twitter_handle,
                facebook: resData.facebook_handle,
                instagram: resData.instagram_handle,
                channelDescription: resData['description'],
                loading: false
            })
        //};
    }
    // select search presentation
    handleChangeFeaturedPk = (selectedOption) => {
        //const { match: { params: { friendly_url } = {} } = {} } = this.props;
        const { channelEntityId, presentationDataArr } = this.state;
        let presentations = []; let selectedTempArr = [];
        presentationDataArr.forEach(async (item) => {
            if (selectedOption === item) {
                selectedTempArr.push(item)
                presentations.push({
                    "entity_uuid": item.entity_uuid,
                    "xref_data": {
                        "spotlighted_time": get_current_unix_stamp()
                    }
                })
                const payload = { presentations };
                //let presentation_patch_data = await axios.patch(`${channel_list_api}/${channelEntityId}`, payload);
                await axios.patch(`${channel_list_api}/${channelEntityId}`, payload);
                //let [selectedPres,dummy] = await Promise.all([
                await Promise.all([
                    //axios.get(`${channel_list_api}/${channelEntityId}/presentations?sort[spotlighted_time]=desc&limit=1`, myHeaders_With_Cache_Control),
                    axios.get(`${channel_list_api}/${channelEntityId}/presentations?sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`, myHeaders_With_Cache_Control),
                    //axios.get(`${channel_list_api}/${this.props.channel_data.friendly_url}/presentations?sort[spotlighted_time]=desc&limit=1`, myHeaders_With_Cache_Control) // to break cache on actual city page
                    axios.get(`${channel_list_api}/${this.props.channel_data.friendly_url}/presentations?sort_obj=${encodeURIComponent('{"spotlighted_time":"desc"}')}&limit=1`, myHeaders_With_Cache_Control) // to break cache on actual city page
                ]);
            }

        });
        this.setState({ selectedData: selectedTempArr })
    }
    // getChangedImg will facebook_get_access_token_api 
    getChangedImg = (imgData) => {
        this.setState({ receivedImg: imgData })
    }

    // getChangedSocialLinks will facebook_get_access_token_api 
    getChangedSocialLinks = (SocialLinksData) => {
        return (SocialLinksData.status === 1) ? this.setState({ twitter: SocialLinksData.value }) : (SocialLinksData.status === 2) ? this.setState({ facebook: SocialLinksData.value }) : this.setState({ instagram: SocialLinksData.value })
    }

    // Update city method
    updateCity = async () => {
        const {
            receivedImg,
            twitter,
            facebook,
            instagram,
            channelDescription,
            channelEntityId,
            //    multipleImagesArr
        } = this.state;
        this.setState({ updateCityLoader: true })

        // JBB - should be calling 1 patch here for all of this
        let patch_obj = {};
        if (twitter !== undefined && !null) {
            patch_obj.twitter_handle = twitter;
        }
        if (facebook !== undefined && !null) {
            patch_obj.facebook_handle = facebook;
        }
        if (twitter !== undefined && !null) {
            patch_obj.instagram_handle = instagram;
        }
        if (channelDescription !== undefined && channelDescription !== '') {
            patch_obj['description'] = channelDescription;
        }
        if (Object.keys(patch_obj).length > 0) {
            await axios.patch(`${channel_list_api}/${channelEntityId}`, patch_obj, myHeaders_Autorized);
            this.setState({ updateCityLoader: false });
        }

        if (receivedImg !== null) {
            // getting array buffer in profilePicPromise
            this.setState({ updateCityLoader: true })
            let coverPicPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(receivedImg);
                reader.onload = () => resolve(reader.result);
            });

            var conImgName = receivedImg.name.replace(/[^A-Za-z0-9.]/g, "");
            let logo_image_upload_data = await axios.post(`${channel_list_api}/${channelEntityId}/getUploadSignedUrl?asset_type=logo_image&filename=${conImgName}`, {}, myHeaders_Autorized);
            const config = { headers: { "Content-Type": logo_image_upload_data.data.content_type } };
            let uploadUrl = logo_image_upload_data.data.upload_url;
            var arrVal = await coverPicPromise;
            await axios.put(uploadUrl, arrVal, config)
        }
        window.location.reload();
    }


    myChangeHandler = (event) => {
        if (event.target.id === "validationDescription") {
            this.setState({ channelDescription: event.target.value });
        }
    }


    render() {
        
        let Channel_or_Team = 'Channel';
        let channel_or_team = 'channel';
        if (this.workspace_base_url) {
            Channel_or_Team = 'Team';
            channel_or_team = 'team';
        }
        
        const { updateCityLoader, channelEntityId, channelImg, twitter, facebook, instagram, channelFriendly_url, channelDescription,
            channelAdminData, loading, presentationDataArr,selectedData } = this.state;
        if (loading) {
            return (
                <div className="createEventSpinner">
                    <ActivityIndicator theme="spinner" />
                </div>
            )
        }
        else {
            return (
                <div className="city-info">
                    <div className="container pad-bot30">
                        <Row className="pad-top70 pad-bot30 editCity">
                            <Col lg={6} md={6} sm={6} className="pad0" >
                                <h1>{Channel_or_Team} Info&nbsp;
                                    <span>
                                        <ShareAccessModalButton entity_info={{...this.channelInfo, entity_type:'channels'}} />
                                    </span>
                                </h1>
                            </Col>
                            <Col lg={6} md={6} sm={6} className="pad0" >
                                <div className="cityUpdate-btn">
                                    <NavLink to={`${local_routes.channels}/${channelFriendly_url}`}>
                                        <Button theme="btn-global btn-hover btn-cancel ">Cancel</Button>
                                    </NavLink>
                                    {
                                        updateCityLoader === false ?
                                            <Button OnClickMet={this.updateCity} theme="btn-global btn-hover btn-green btn-update">Update Channel</Button>
                                            :
                                            <ActivityIndicator theme="button-Status-Loader" />
                                    }
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} className="pad0" >
                                <Form.Group controlId="validationDescription">
                                    <Form.Label>DESCRIPTION</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        value={channelDescription}
                                        onChange={this.myChangeHandler}
                                        placeholder={`Write 2-4 sentences that describe your ${Channel_or_Team}`}
                                        rows="6"
                                    //required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} className="coverphoto pad0 mb-4">
                                <div className="pad-tb30 cover-border">
                                    <h3>Featured PK</h3>
                                    <p>Please select one Featured PK to show in spotlighted section of {channel_or_team}</p>
                                </div>
                                <Row>
                                    <Col md={7}>
                                        <div className="presentation-multi-select mb-3">
                                            <Select
                                                closeMenuOnSelect={true}
                                                // defaultValue={receivedProps ? apiCategories : selected}
                                                // defaultValue={[presentationDataArr[1]]}
                                                //value={selectedValues.length > 0 ? selectedValues : selected}
                                                value={selectedData}
                                                onChange={this.handleChangeFeaturedPk}
                                                options={presentationDataArr}
                                                isMulti={false}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="cover-photo">
                            <CoverPhoto
                                cityEntityId={channelEntityId}
                                cityImg={channelImg}
                                changedImg={this.getChangedImg}
                                currentImageText={"CURRENT LOGO IMAGE"}
                                replaceImageBtn={"Replace Logo Image"}
                                coverHead="Logo Image"
                                coverDescription={`Displayed at the top of your ${channel_or_team} page`}
                                coverImage={PlaceholderImage}
                            />
                        </Row>
                        <Row>
                            <SocialMedia
                                twitter={twitter}
                                facebook={facebook}
                                instagram={instagram}
                                changedSocialLinks={this.getChangedSocialLinks}
                                mediaHeading="Social Media Links"
                                mediaSubHead={`Link to social media accounts associated with this ${channel_or_team}`}
                            />
                        </Row>
                        
                        <Row className="d-flex justify-center">
                            <div className="cityUpdate-btn">
                                <NavLink to={`${local_routes.channels}/${channelFriendly_url}`}>
                                    <Button theme="btn-global btn-hover btn-cancel ">Cancel</Button>
                                </NavLink>
                                {
                                    updateCityLoader === false ?
                                        <Button OnClickMet={this.updateCity} theme="btn-global btn-hover btn-green btn-update">Update {Channel_or_Team}</Button>
                                        :
                                        <ActivityIndicator theme="button-Status-Loader" />
                                }
                            </div>
                        </Row>
                    </div>
                </div>
            );
        }

    }
}

export default ChannelInfo;
